<template>
  <div>
    <modal-form v-model="show" :submit="submit" :show-submit="userHasRole('MarcarDocumentoNaoPendenteProposta')" size="md" text-submit="Concluir itens pendentes">
      <template v-slot:title>
        Pendências da Proposta - {{ model.CodigoPropostaAN }}
      </template>
      <template v-slot:body>
        <v-list dense class="lista-acoes">
          <template >
            <v-row no-gutters>
            <v-col cols="*">
              <v-list-item @click="visualizarProposta()">
                <v-list-item-icon>
                  <v-icon>far fa-file</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Resumo da Proposta</v-list-item-title>
              </v-list-item>
            </v-col>
          </v-row>
            <v-row no-gutters v-if="userHasRole('UploadDocumentoPessoa') || userHasRole('ListPessoaDocumentoByDtInclusaoProposta')">
              <v-col cols="*">
                <v-list-item :disabled="!userHasRole('UploadDocumentoPessoa')" @click="enviarDocumentoPessoa()">
                  <v-list-item-icon><v-icon>fa fa-upload</v-icon></v-list-item-icon>
                  <v-list-item-title>Enviar Documentos da Pessoa</v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col cols="4">
                <v-btn block :disabled="!userHasRole('ListPessoaDocumentoByDtInclusaoProposta')" class="mt-1" small @click="verDocumentoPessoa" color="primary" outlined elevation="2">
                  <v-icon small class="mr-2">fa fa-eye</v-icon>
                  Ver Documentos
                </v-btn>
              </v-col>
            </v-row>

            <v-row no-gutters v-if="userHasRole('UploadDocumentoProposta') || userHasRole('ListPropostaDocumento')">
              <v-col cols="*">
                <v-list-item :disabled="!userHasRole('UploadDocumentoProposta')" @click="enviarDocumentoProposta([30, 40, 68])">
                  <v-list-item-icon><v-icon>fa fa-upload</v-icon></v-list-item-icon>
                  <v-list-item-title>Enviar Documentos da Proposta</v-list-item-title>
                </v-list-item>
              </v-col>
              <v-col cols="4">
                <v-btn block :disabled="!userHasRole('ListPropostaDocumento')" class="mt-1" small @click="verDocumentoProposta" color="primary" outlined elevation="2">
                  <v-icon small class="mr-2">fa fa-eye</v-icon>
                  Ver Documentos
                </v-btn>
              </v-col>
            </v-row>
          </template>

        </v-list>

        <v-row>
          <v-col cols="12">
            <input-textarea label="Pendências" v-model="model.TextoPendenteConferencia" rows="5" disabled></input-textarea>

            <v-checkbox disabled hide-details label="Possui pendências por parte dos documentos do cliente?" v-model="model.PendenteDoctoCliente"></v-checkbox>
            <v-checkbox disabled hide-details label="Possui pendências por parte dos documentos da proposta?" v-model="model.PendenteDoctoProposta"></v-checkbox>
            <v-checkbox disabled hide-details label="Malote pendente ou documento faltante?" v-model="model.PendenteConferenciaMalote"></v-checkbox>
          </v-col>
        </v-row>
      </template>
    </modal-form>
    <DocumentoEdit ref="documentoEdit" :tipo="$aux.TipoDocumentoEntidade.Proposta" :documentoCliente="model.Cliente.DocumentoFederal" :codigoProposta="model.Codigo"/>
    <DocumentoEdit ref="uploadDocumento" :tipo="$aux.TipoDocumentoEntidade.Pessoa" :documentoCliente="model.Cliente.DocumentoFederal" :codigoProposta="model.Codigo" :codigoPessoa="model.CodigoCliente" validadeRequired/>
    <DocumentoModal ref="documento" :tipo="$aux.TipoDocumentoEntidade.Pessoa" :codigoPessoa="model.CodigoCliente" :codigoProposta="model.Codigo"/>
    <DocumentoModal ref="documentoProposta" :tipo="$aux.TipoDocumentoEntidade.Proposta" :codigoProposta="model.Codigo"/>
    <PropostaVisualizar ref="visualizar" />
  </div>
</template>
<script>
export default {
  components: {
    PropostaVisualizar: () => import('./PropostaVisualizar'),
  },
  data () {
    return {
      show: false,
      model: {
        Cliente: {}
      }
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      if (sender) {
        th.$api.Multiplo.FindRecordProposta({ guidID: sender.Codigo }).then(function (response) {
          if (th.$api.UI.PostLoadData(response, true)) {
            th.$set(th, 'model', response)
          }
        })
      }
    },
    submit () {
      const th = this
      th.$api.UI.Confirmacao('alerta', 'Confirma a conclusão dos itens pendentes?', function () {
        th.$api.Multiplo.MarcarDocumentoNaoPendenteProposta({ guidID: th.model.Codigo }).then(function (response) {
          if (th.$api.UI.PostAction(response)) {
            th.$emit('close', response)
            th.show = false
          }
        })
      })
    },
    enviarDocumentoPessoa () {
      this.$refs.uploadDocumento.openModal()
    },
    verDocumentoPessoa () {
      this.$refs.documento.openModal(this.model)
    },
    enviarDocumentoProposta (tipos) {
      this.$refs.documentoEdit.openModal(null, tipos)
    },
    verDocumentoProposta (e) {
      e.preventDefault()
      this.$refs.documentoProposta.openModal(this.model)
    },
    visualizarProposta () {
      this.$refs.visualizar.openModal(this.model)
    },
  }
}
</script>
